import { Link } from 'react-router-dom';
import { footerLinks, footerContact } from '@/mocks/navigation';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-200">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <Link to="/" className="font-heading text-xl font-bold text-background-50 cursor-pointer">
              开云体育
            </Link>
            <p className="mt-4 text-sm text-foreground-400 leading-relaxed">
              开云体育平台是专业的在线体育竞技服务平台，覆盖足球、篮球、网球等数百种赛事，为您提供顶级的体育竞技体验。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="QQ">
                <i className="ri-qq-line text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">平台导航</h4>
            <ul className="space-y-2.5">
              {footerLinks.platforms.map((link) => (
                <li key={link.label}>
                  <Link to={link.href} className="text-sm text-foreground-400 hover:text-background-100 transition-colors cursor-pointer">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">赛事服务</h4>
            <ul className="space-y-2.5">
              {footerLinks.services.map((link) => (
                <li key={link.label}>
                  <Link to={link.href} className="text-sm text-foreground-400 hover:text-background-100 transition-colors cursor-pointer">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">帮助支持</h4>
            <ul className="space-y-2.5">
              {footerLinks.support.map((link) => (
                <li key={link.label}>
                  <Link to={link.href} className="text-sm text-foreground-400 hover:text-background-100 transition-colors cursor-pointer">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="mt-5 pt-5 border-t border-foreground-800">
              <p className="text-sm text-foreground-400">
                <i className="ri-phone-line mr-2"></i>
                {footerContact.serviceHotline}
              </p>
              <p className="text-sm text-foreground-400 mt-2">
                <i className="ri-mail-line mr-2"></i>
                {footerContact.email}
              </p>
              <p className="text-sm text-foreground-500 mt-2">
                {footerContact.workHours}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-800">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2026 开云体育平台 版权所有 | 菲律宾马尼拉博彩监管区牌照运营
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-background-200 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-background-200 transition-colors cursor-pointer">服务条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-background-200 transition-colors cursor-pointer">责任博彩</a>
          </div>
        </div>
      </div>
    </footer>
  );
}